import { useApi } from "../../api/hooks/use-api.ts";
import { ApiResponseType } from "../../api/types.ts";
import { ApiMethod } from "../../api/types.ts";
import { asObject } from "../../api/payload.ts";

export const useListsApi = () => {
    const { sendProtectedRequest } = useApi();
    const listCache: Map<string, any> = new Map();

    // All CRM lists keyed by name: { <listname>: { entries: [...] } }. Resolves
    // to an empty object when the request fails, so getList rejects cleanly.
    const getLists = async () => {
        if (listCache.has('lists')) {
            return listCache.get('lists');
        }
        const response = sendProtectedRequest(ApiMethod.GET, process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT + '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN + '&action=lists');

        return response.then(data => {
            if (data.type !== ApiResponseType.OK) {
                return {};
            }
            const lists = asObject(data.payload);
            if (!listCache.has('lists')) {
                listCache.set('lists', lists);
            }
            return lists;
        });
    };

    const getList = async (listname:string): Promise<any> => {
        return new Promise((resolve, reject) => {
            getLists().then(res => {
                if (res[listname]) {
                    resolve(res[listname].entries);
                } else {
                    reject([]);
                }
            }).catch(() => reject([]));
        });
    }

    return { getLists, getList };
};
